import Rellax from 'rellax';

class Parallax {
    /**
     * @param {Element|Node} wrapper
     */
    constructor(wrapper) {
        const {parallaxSelector} = wrapper.dataset;
        let {relativeToWrapper} = wrapper.dataset;
        const {parallaxBreakpoint} = wrapper.dataset;
        this.debounce = null;
        this.options = {};

        this.parallaxElements = wrapper.querySelectorAll(parallaxSelector);
        if (!this.parallaxElements) return;

        if (relativeToWrapper) {
            relativeToWrapper = parseInt(relativeToWrapper, 10);
            this.options = {wrapper, relativeToWrapper};
        }

        if (parallaxBreakpoint) {
            this.parallaxBreakpoint = parseInt(parallaxBreakpoint, 10);
        }

        this.registerEventListeners();
        this.init();
    }

    init() {
        if (!this.parallaxEnabled || this.object) return;

        this.parallaxElements.forEach((element) => {
            this.object = new Rellax(element, this.options);
        });
    }

    registerEventListeners() {
        if (this.parallaxBreakpoint) {
            window.addEventListener('resize', () => {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(this.handleResize.bind(this), 500);
            });
        }
    }

    handleResize() {
        if (!this.parallaxEnabled && this.object) {
            this.object.destroy();
            this.object = null;
        } else {
            this.init();
        }
    }

    get parallaxEnabled() {
        if (this.parallaxBreakpoint) {
            return window.innerWidth >= this.parallaxBreakpoint;
        }

        return true;
    }
}

const parallax = {
    init() {
        const wrappers = document.querySelectorAll('.js-rellax-wrapper');

        if (!wrappers.length) return;

        wrappers.forEach((wrapper) => {
            // eslint-disable-next-line no-new
            new Parallax(wrapper);
        });
    },
};

export default parallax;
